import { RouteType } from "../@types/RouteType";
import {
    LeadsRoutes,
    DashboardRoutes,
    FinancialRoutes,
    GeneralRoutes,
    OrderRoutesWInventory,
    RegistrationRoutes,
    ResourcesRoutes,
    TechSupportRoutes,
    WarrantyClaimRoutes
} from "./MainRoutes";


const DealerAdminRoutes: RouteType[] = [
    ...DashboardRoutes,
    ...OrderRoutesWInventory,
    ...RegistrationRoutes,
    ...WarrantyClaimRoutes,
    ...TechSupportRoutes,
    ...FinancialRoutes,
    ...LeadsRoutes,
    ...ResourcesRoutes,
    ...GeneralRoutes,
]

export default DealerAdminRoutes;